import { Grid } from "@octopus-energy/coral/atoms"
import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { StoryblokComponent, storyblokEditable } from "@storyblok/react"
import { type SbBlokCollapsingGrid } from "../types"

interface DynamicCollapsingGridProps {
    blok: SbBlokCollapsingGrid
}

export default function DynamicCollapsingGrid({ blok }: DynamicCollapsingGridProps) {
    if (!blok?.blocks?.length) {
        return (
            <StoryblokMissingField
                blok="CollapsingGrid"
                field="Blocks"
            />
        )
    }

    if (!blok.columns) {
        return (
            <StoryblokMissingField
                blok="CollapsingGrid"
                field="Columns"
            />
        )
    }

    const columns = blok.columns ? parseInt(blok.columns, 10) : undefined

    return (
        <Grid
            {...storyblokEditable(blok)}
            gridTemplateColumns={{
                base: "1fr",
                md: `repeat(${columns}, 1fr)`,
            }}
        >
            {blok.blocks.map((nestedBlok) => (
                <StoryblokComponent
                    blok={nestedBlok}
                    key={nestedBlok._uid}
                />
            ))}
        </Grid>
    )
}
